export const ROOT = 'common/header/breadCrumb';

export const SET_TITLE_BREADCRUMB = `${ROOT}/SET_TITLE_BREADCRUMB`;
export const SET_POSITIONOF_BREADCRUMB = `${ROOT}/SET_POSITIONOF_BREADCRUMB`;
